module.exports = __webpack_public_path__ + "images/emoji/cl.009ae7210d4755777ca1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cl.png
// module id = 5/hO
// module chunks = 24